import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import { Preloader } from '@/components/Preloader';
import { useUserStore } from '@/store/userStore';
import { setDirectAccessToken } from '@/helpers/authSession';

const AuthDirectPage = () => {
  const { search } = useLocation();
  const { setAccessToken } = useUserStore();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get('token');

  const login = useCallback(
    async token => {
      if (!token) return navigate(APP_LINKS.auth);
      setDirectAccessToken(token);
      await setAccessToken(token);
      navigate(APP_LINKS.dashboard, { replace: true });
    },
    [navigate, setAccessToken],
  );

  useEffect(() => {
    login(token);
  }, [token, login]);

  return (
    <div style={{ height: '100vh' }}>
      <Preloader />
    </div>
  );
};

export default AuthDirectPage;
